import { ObjectTypeCode } from './system-type-constants';

export enum Permissions {
  // Claimant Permissions
  ClaimantDetailsView = 'Claimant-View',
  ClaimantDetailsEdit = 'Claimant-Edit',
  ClaimantDetailsCreate = 'Claimant-Create',

  // Claimant Address Permissions
  ClaimantAddressView = 'ClaimantAddress-View',
  ClaimantAddressAdd = 'ClaimantAddress-Add',
  ClaimantAddressEdit = 'ClaimantAddress-Edit',
  ClaimantAddressDelete = 'ClaimantAddress-Delete',

  // Claimant Note Permissions

  ClaimantNoteView = 'ClaimantNote-View',
  ClaimantNoteAdd = 'ClaimantNote-Add',

  // Claimant Contact Permissions
  ClaimantContactView = 'ClaimantContact-View',
  ClaimantContactAdd = 'ClaimantContact-Add',

  // Dashboard Administration
  DashboardAdministrationManageQueues = 'DashboardAdministration-ManageQueues',

  // Document
  DocumentView = 'Document-View',
  DocumentUploadDocument = 'Document-UploadDocument',
  DocumentAddDocumentFromTemplate = 'Document-AddDocumentfromTemplate',

  // Document Template Administration
  DocumentTemplateAdministrationView = 'DocumentTemplateAdministration-View',
  DocumentTemplateAdministrationCreate = 'DocumentTemplateAdministration-Create',
  DocumentTemplateAdministrationEdit = 'DocumentTemplateAdministration-Edit',

  // Document Details
  DocumentDetailsDocumentView = 'DocumentDetails-ViewDocument',
  DocumentDetailsDownloadDocument = 'DocumentDetails-DownloadDocument',
  DocumentDetailsDownloadwithRelatedDocuments = 'DocumentDetails-DownloadwithRelatedDocuments',
  DocumentDetailsPrintDocument = 'DocumentDetails-PrintDocument',
  DocumentDetailsEdit = 'DocumentDetails-Edit',
  DocumentDetailsChangeForm = 'DocumentDetails-ChangeForm',
  DocumentDetailsDeleteDocument = 'DocumentDetails-DeleteDocument',
  DocumentDetailsMoveDocument = 'DocumentDetails-MoveDocument',
  DocumentDetailsDistributeDocument = 'DocumentDetails-DistributeDocument',

  // Document Note Permissions
  DocumentNoteView = 'DocumentNote-View',
  DocumentNoteAdd = 'DocumentNote-Add',

  // Employer Permissions
  EmployerDetailsView = 'Employer-View',

  // Employer Address Permissions
  EmployerAddressView = 'EmployerAddress-View',
  EmployerAddressAdd = 'EmployerAddress-Add',
  EmployerAddressEdit = 'EmployerAddress-Edit',
  EmployerAddressDelete = 'EmployerAddress-Delete',

  // Employer Note Permissions
  EmployerNoteView = 'EmployerNote-View',
  EmployerNoteAdd = 'EmployerNote-Add',

  // Employer Contact Permissions
  EmployerContactView = 'EmployerContact-View',
  EmployerContactAdd = 'EmployerContact-Add',

  // History Audit Trail
  HistoryAuditTrailView = 'History-AuditTrail-View',

  // HealthcareProvider Address Permissions
  HealthcareProviderAddressView = 'HealthcareProviderAddress-View',
  HealthcareProviderAddressAdd = 'HealthcareProviderAddress-Add',
  HealthcareProviderAddressEdit = 'HealthcareProviderAddress-Edit',
  HealthcareProviderAddressDelete = 'HealthcareProviderAddress-Delete',

  // HealthcareProvider Note Permissions
  HealthcareProviderNoteView = 'HealthcareProviderNote-View',
  HealthcareProviderNoteAdd = 'HealthcareProviderNote-Add',

  // HealthcareProvider Contact Permissions
  HealthcareProviderContactView = 'HealthcareProviderContact-View',
  HealthcareProviderContactAdd = 'HealthcareProviderContact-Add',

  // Healthcare Provider Relationships Permissions
  HealthcareProviderRelationshipsView = 'HealthcareProviderRelationships-View',
  HealthcareProviderRelationshipsAdd = 'HealthcareProviderRelationships-Add',
  HealthcareProviderRelationshipsEdit = 'HealthcareProviderRelationships-Edit',
  HealthcareProviderRelationshipsDelete = 'HealthcareProviderRelationships-Delete',

  // Healthcare Provider Impartial Specialist Designations Permissions
  HealthcareProviderImpartialSpecialistDesignationsView = 'HealthcareProviderImpartialSpecialistDesignations-View',
  HealthcareProviderImpartialSpecialistDesignationsAdd = 'HealthcareProviderImpartialSpecialistDesignations-Add',
  HealthcareProviderImpartialSpecialistDesignationsEdit = 'HealthcareProviderImpartialSpecialistDesignations-Edit',
  HealthcareProviderImpartialSpecialistDesignationsDelete = 'HealthcareProviderImpartialSpecialistDesignations-Delete',

  // Healthcare Provider Related PARs Permissions
  HealthcareProviderRelatedPriorAuthsView = 'HealthcareProviderRelatedPriorAuths-View',

  // Insurer Permissions
  InsurerDetailsView = 'Insurer-View',

  // Insurer Address Permissions
  InsurerAddressView = 'InsurerAddress-View',
  InsurerAddressAdd = 'InsurerAddress-Add',
  InsurerAddressEdit = 'InsurerAddress-Edit',
  InsurerAddressDelete = 'InsurerAddress-Delete',

  // Insurer Note Permissions
  InsurerNoteView = 'InsurerNote-View',
  InsurerNoteAdd = 'InsurerNote-Add',

  // Insurer Contact Permissions
  InsurerContactView = 'InsurerContact-View',
  InsurerContactAdd = 'InsurerContact-Add',

  InternalWorkRequestManageWorkgroupQueue = 'InternalWorkRequest-ManageWorkgroupQueue',

  // Insurer Group Permissions
  InsurerGroupView = 'InsurerGroup-View',

  // Insurer-TPA Relationships Permissions
  InsurerTPARelationshipsView = 'InsurerTPARelationships-View',

  // MDOReview
  MDOReviewsView = 'MDOReviews-View',
  MDOReviewsIgnoreStatusUpdateRestrictions = 'MDOReviews-IgnoreStatusUpdateRestrictions',

  MDOReviewDetailView = 'MDOReview-View',
  MDOReviewDetailEditRejectionandSupervisorReview = 'MDOReview-EditRejectionandSupervisorReview',
  MDOReviewDetailAddEditDeterminations = 'MDOReview-AddEditDeterminations',
  MDOReviewDetailAddEditDeterminationsOnceApproved = 'MDOReview-AddEditDeterminationsOnceApproved',
  MDOReviewDetailAddEditDeterminationsOnceConditionallyApprovedOrRejected = 'MDOReview-AddEditDeterminationsOnceConditionallyApprovedOrRejected',
  MDOReviewDetailUpdateStatus = 'MDOReview-UpdateStatus',
  MDOReviewDetailInternalReviewerUpdateStatus = 'MDOReview-InternalReviewerUpdateStatus',
  MDOReviewDetailExternalReviewerUpdateStatus = 'MDOReview-ExternalReviewerUpdateStatus',
  MDOReviewDetailPreviewNOR = 'MDOReview-PreviewNOR',
  MDOReviewDetailIssueNOR = 'MDOReview-IssueNOR',

  MDOReviewObjectAssignmentAlgorithmAdministrationEdit = 'MDOReviewObjectAssignmentAlgorithmAdministration-Edit',

  // MDOReview Note Permissions
  MDOReviewNoteView = 'MDOReviewNote-View',
  MDOReviewNoteAdd = 'MDOReviewNote-Add',

  // Medical Supplier Permissions
  MedicalSupplierDetailsView = 'MedicalSupplier-View',
  MedicalSupplierDetailsEdit = 'MedicalSupplier-Edit',
  MedicalSupplierDetailsCreate = 'MedicalSupplier-Create',

  // Medical Supplier Address Permissions
  MedicalSupplierAddressView = 'MedicalSupplierAddress-View',
  MedicalSupplierAddressAdd = 'MedicalSupplierAddress-Add',
  MedicalSupplierAddressEdit = 'MedicalSupplierAddress-Edit',
  MedicalSupplierAddressDelete = 'MedicalSupplierAddress-Delete',

  // Medical Supplier Note Permissions
  MedicalSupplierNoteView = 'MedicalSupplierNote-View',
  MedicalSupplierNoteAdd = 'MedicalSupplierNote-Add',

  // Medical Supplier Contact Permissions
  MedicalSupplierContactView = 'MedicalSupplierContact-View',
  MedicalSupplierContactAdd = 'MedicalSupplierContact-Add',

  // Medical Bill Dispute Permissions
  MedicalBillDisputeDetailsView = 'MedicalBillingDispute-View',
  MedicalBillDisputeUpdateStatus = 'MedicalBillingDispute-UpdateStatus',

  // Medical Billing Dispute Note Permissions
  MedicalBillingDisputeNoteView = 'MedicalBillingDisputeNote-View',
  MedicalBillingDisputeNoteAdd = 'MedicalBillingDisputeNote-Add',

  //Non-SED HealthcareProvider Permissions
  NonSEDHealthcareProviderDetailsView = 'NonSEDHealthcareProvider-View',
  NonSEDHealthcareProviderDetailsEdit = 'NonSEDHealthcareProvider-Edit',
  NonSEDHealthcareProviderDetailsCreate = 'NonSEDHealthcareProvider-Create',

  // Non-SED HealthcareProvider Address Permissions
  NonSEDHealthcareProviderAddressView = 'NonSEDHealthcareProviderAddress-View',
  NonSEDHealthcareProviderAddressAdd = 'NonSEDHealthcareProviderAddress-Add',
  NonSEDHealthcareProviderAddressEdit = 'NonSEDHealthcareProviderAddress-Edit',
  NonSEDHealthcareProviderAddressDelete = 'NonSEDHealthcareProviderAddress-Delete',

  // Onboard User Administration
  OnboardUserAdministrationAddEditUser = 'OnboardUserAdministration-AddEditUser',
  OnboardUserAdministrationAddRemoveSystemAccessGroup = 'OnboardUserAdministration-AddRemoveSystemAccessGroup',
  OnboardUserAdministrationAddRemoveWorkgroup = 'OnboardUserAdministration-AddRemoveWorkgroup',
  OnboardUserAdministrationAddRemoveQueues = 'OnboardUserAdministration-AddRemoveQueues',

  // Prior Authorization Request Permissions
  PriorAuthorizationRequestDetailsView = 'PriorAuthorizationRequest-View',

  // Prior Authorization Note  Permissions
  PriorAuthorizationNoteView = 'PriorAuthorizationNote-View',
  PriorAuthorizationNoteAdd = 'PriorAuthorizationNote-Add',

  QAUserRoleCreate = 'QA-User-Role-Create',

  // Related Prior Auth Requests Permissions
  RelatedPriorAuthRequestsView = 'RelatedPriorAuthRequests-View',

  // Related Entities & Users
  RelatedEntitiesUsersView = 'RelatedEntitiesUsers-View',
  RelatedEntitiesUsersAddUser = 'RelatedEntitiesUsers-AddUser',
  RelatedEntitiesUsersEditUser = 'RelatedEntitiesUsers-EditUser',
  RelatedEntitiesUsersRemoveAll = 'RelatedEntitiesUsers-RemoveAll',
  RelatedEntitiesUsersEditSenderNum = 'RelatedEntitiesUsers-EditSenderNum',

  // Reference Data Administration Permissions
  ReferenceDataAdministrationAddEditData = 'ReferenceDataAdministration-AddEditData',

  // Scanning Metadata Subsection Permissions
  ScanningMetadataView = 'ScanningMetadata-View',

  // SED HealthcareProvider  Permissions
  SEDHealthcareProviderDetailsView = 'SEDHealthcareProvider-View',
  SEDHealthcareProviderDetailsEdit = 'SEDHealthcareProvider-Edit',

  SEDHealthcareProviderLicenseView = 'SEDHealthcareProviderLicense-View',
  SEDHealthcareProviderLicenseAddressView = 'SEDHealthcareProviderLicenseAddress-View',
  SEDHealthcareProviderLicenseAddressAdd = 'SEDHealthcareProviderLicenseAddress-Add',
  SEDHealthcareProviderLicenseAddressEdit = 'SEDHealthcareProviderLicenseAddress-Edit',
  SEDHealthcareProviderLicenseAddressDelete = 'SEDHealthcareProviderLicenseAddress-Delete',

  SEDHealthcareProviderLicenseSpecialtiesView = 'SEDHealthcareProviderCertification-View',
  SEDHealthcareProviderLicenseSpecialtiesAdd = 'SEDHealthcareProviderCertification-Add',
  SEDHealthcareProviderLicenseSpecialtiesEdit = 'SEDHealthcareProviderCertification-Edit',
  SEDHealthcareProviderLicenseSpecialtiesDelete = 'SEDHealthcareProviderCertification-Delete',

  // SED HealthcareProvider Certification/Rating  Permissions
  SEDHealthcareProviderCertificationRatingView = 'SEDHealthcareProviderCertificationRating-View',
  SEDHealthcareProviderCertificationRatingAdd = 'SEDHealthcareProviderCertificationRating-Add',
  SEDHealthcareProviderCertificationRatingEdit = 'SEDHealthcareProviderCertificationRating-Edit',
  SEDHealthcareProviderCertificationRatingDelete = 'SEDHealthcareProviderCertificationRating-Delete',

  // SED HealthcareProvider Address  Permissions
  SEDHealthcareProviderAddressView = 'SEDHealthcareProviderAddress-View',
  SEDHealthcareProviderAddressAdd = 'SEDHealthcareProviderAddress-Add',
  SEDHealthcareProviderAddressEdit = 'SEDHealthcareProviderAddress-Edit',
  SEDHealthcareProviderAddressDelete = 'SEDHealthcareProviderAddress-Delete',

  // Specific Prior Auth Request Details Permissions
  SpecificPriorAuthRequestDetailsView = 'SpecificPriorAuthRequestDetails-View',

  // Status & Work Request Administration Permissions
  AutoWorkRequestView = 'AutoWorkRequest-View',
  AutoWorkRequestCreate = 'AutoWorkRequest-Create',
  AutoWorkRequestEdit = 'AutoWorkRequest-Edit',
  AutoWorkRequestDelete = 'AutoWorkRequest-Delete',

  ObjectStatusCreate = 'ObjectStatus-Create',
  ObjectStatusDelete = 'ObjectStatus-Delete',
  ObjectStatusEdit = 'ObjectStatus-Edit',
  ObjectStatusView = 'ObjectStatus-View',

  WorkRequestTypeCreate = 'WorkRequestType-Create',
  WorkRequestTypeDelete = 'WorkRequestType-Delete',
  WorkRequestTypeEdit = 'WorkRequestType-Edit',
  WorkRequestTypeView = 'WorkRequestType-View',

  // System Access Group Administration
  SystemAccessGroupAdministrationAddRemoveUsers = 'SystemAccessGroupAdministration-AddRemoveUsers',

  // Third Party Administrator Permissions
  ThirdPartyAdministratorDetailsView = 'ThirdPartyAdministrator-View',
  ThirdPartyAdministratorDetailsEdit = 'ThirdPartyAdministrator-Edit',
  ThirdPartyAdministratorDetailsCreate = 'ThirdPartyAdministrator-Create',

  // Third Party Administrator Address Permissions
  ThirdPartyAdministratorAddressView = 'ThirdPartyAdministratorAddress-View',
  ThirdPartyAdministratorAddressAdd = 'ThirdPartyAdministratorAddress-Add',
  ThirdPartyAdministratorAddressEdit = 'ThirdPartyAdministratorAddress-Edit',
  ThirdPartyAdministratorAddressDelete = 'ThirdPartyAdministratorAddress-Delete',

  // Third Party Administrator Note Permissions
  ThirdPartyAdministratorNoteView = 'ThirdPartyAdministratorNote-View',
  ThirdPartyAdministratorNoteAdd = 'ThirdPartyAdministratorNote-Add',

  // Third Party Administrator Contact Permissions
  ThirdPartyAdministratorContactView = 'ThirdPartyAdministratorContact-View',
  ThirdPartyAdministratorContactAdd = 'ThirdPartyAdministratorContact-Add',

  // TPA-Insurer Relationships Permissions
  TPAInsurerRelationshipsView = 'TPAInsurerRelationships-View',

  // Workgroup Administration
  WorkgroupAdministrationAddEditWorkgroup = 'WorkgroupAdministration-AddEditWorkgroup',
  WorkgroupAdministrationAddRemoveUsers = 'WorkgroupAdministration-AddRemoveUsers',
  WorkgroupAdministrationAddRemoveAssignors = 'WorkgroupAdministration-AddRemoveAssignors',

  // Work Request Permissions
  WorkRequestView = 'InternalWorkRequest-View',
  WorkRequestBasicEdit = 'InternalWorkRequest-BasicEdit',
  WorkRequestFullEdit = 'InternalWorkRequest-FullEdit',
  WorkRequestInternalAdd = 'InternalWorkRequest-Create',

  // Work Requests for Internal Users on Objects in Your Functional Area Permissions

  WorkRequestsforInternalUsersonObjectsinYourFunctionalAreaEdit = 'WorkRequestsforInternalUsersonObjectsinYourFunctionalArea-Edit',
  WorkRequestsforInternalUsersonObjectsinYourFunctionalAreaView = 'WorkRequestsforInternalUsersonObjectsinYourFunctionalArea-View',

  // Work Requests for External Users on Objects Permissions
  WorkRequestsEntitiesOnObjectsView = 'WorkRequestsforExternalUsersEntitiesonObjects-View',
  WorkRequestsEntitiesOnObjectsEdit = 'WorkRequestsforExternalUsersEntitiesonObjects-Edit',

  // Work Requests for External Entities on Objects Permissions
  WorkRequestsEntitiesOnEntitiesView = 'WorkRequestsforExternalUsersEntitiesonEntities-View',
  WorkRequestsEntitiesOnEntitiesEdit = 'WorkRequestsforExternalUsersEntitiesonEntities-Edit',

  // External User Workload Admin
  ExternalPriorAuthorizationsCardsView = 'External-Prior-Authorizations-Cards-View',

  // Correspondence History Subsection
  CorrespondenceHistorySubsectionView = 'CorrespondenceHistorySubsection-View',

  // Job Management / Admin
  JobManagementView = 'JobManagement-View',
  JobManagementRetry = 'JobManagement-Retry',

  // TO DO: Add permission for MDO Supervisor
  // MDOSupervisor = 'Update-MDO-Review-Status';
}

export const PermissionSets = {
  AdminDashboard: [
    Permissions.OnboardUserAdministrationAddEditUser,
    Permissions.OnboardUserAdministrationAddRemoveQueues,
    Permissions.OnboardUserAdministrationAddRemoveWorkgroup,
    Permissions.OnboardUserAdministrationAddRemoveSystemAccessGroup,
    Permissions.SystemAccessGroupAdministrationAddRemoveUsers,
    Permissions.WorkgroupAdministrationAddEditWorkgroup,
    Permissions.ReferenceDataAdministrationAddEditData,
    Permissions.MDOReviewObjectAssignmentAlgorithmAdministrationEdit,
  ],
  WorkflowAdminDashboard: [
    Permissions.AutoWorkRequestCreate,
    Permissions.AutoWorkRequestDelete,
    Permissions.AutoWorkRequestEdit,
    Permissions.AutoWorkRequestView,
    Permissions.ObjectStatusCreate,
    Permissions.ObjectStatusDelete,
    Permissions.ObjectStatusEdit,
    Permissions.ObjectStatusView,
    Permissions.WorkRequestTypeCreate,
    Permissions.WorkRequestTypeDelete,
    Permissions.WorkRequestTypeEdit,
    Permissions.WorkRequestTypeView,
  ],
  AdvancedSearch: [
    Permissions.ClaimantDetailsView,
    Permissions.DocumentDetailsDocumentView,
    Permissions.EmployerDetailsView,
    Permissions.InsurerDetailsView,
    Permissions.MedicalSupplierDetailsView,
    Permissions.MDOReviewDetailView,
    Permissions.NonSEDHealthcareProviderDetailsView,
    Permissions.PriorAuthorizationRequestDetailsView,
    Permissions.SEDHealthcareProviderDetailsView,
    Permissions.ThirdPartyAdministratorDetailsView,
  ],
  JobManagement: [Permissions.JobManagementView, Permissions.JobManagementRetry],
};

export enum GroupPermissions {
  groupAdministrator = 1,
  serviceOfProcess = 2,
}

export const ViewPermissionsForObjectType = (typeCode: ObjectTypeCode): Permissions => {
  switch (typeCode) {
    case ObjectTypeCode.Document:
      return Permissions.DocumentDetailsDocumentView;
    case ObjectTypeCode.PriorAuthorization:
      return Permissions.PriorAuthorizationRequestDetailsView;
    case ObjectTypeCode.MedicalBillingDispute:
      return Permissions.MedicalBillDisputeDetailsView;
    case ObjectTypeCode.MdoReviewRequest:
      return Permissions.MDOReviewDetailView;
    default:
      throw new Error(`No permission found for type code ${typeCode}.`);
  }
};
